<header class="header">
  <div class="logo">
    <a routerLink="/my-portals" [attr.aria-label]="'pageHeader.backToPortals' | translate">
      <img [src]="logoSrc" [style.width]="logoWidth" alt="logo de Billcentrix">
    </a>
  </div>
  <div class="buttons">
    <ng-content></ng-content>
    <app-menu></app-menu>
  </div>
</header>
